<!-- CalendarInput -->
<template>
  <div class="calendar-input clearfix zindex-2">
    <div :class="{ 'form-group row': !this.pickerOptions.inline }">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-form-label col-sm-3'" v-if="!pickerOptions.noLabel">
        {{ pickerOptions.label }}
        <span v-if="pickerOptions.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : { 'col-sm-9' : !pickerOptions.noLabel }">
        <input class="form-control" ref="input"
        :type="type"
        :name="pickerOptions.name"/>
      </div>
    </div>
  </div>
</template>

<script>
  import dom from '@/util/dom'
  import moment from 'moment-timezone'

  export default {
    name: 'CalendarInput',
    props: {
      value: {
        type: [String, Date]
      },
      options: {
        type: Object
      },
      selectedDates: {
        type: Array
      },
      loadDates: {
        type: Function
      },
      getMonthReports: {
        type: Function
      },
      goToDate: {
        type: Function
      }
    },
    data () {
      return {
        picker: {},
        isDirty: false,
        isValid: true,
        selectedDate: null,
      }
    },
    updated () {
      if (this.value && !moment(this.value).isSame(moment(this.picker._d))) {
        this.picker.setMoment(moment(this.value))
        this.$emit('input', this.value)
        this.goToDate(this.value)
      }
      if (this.value === null) {
        // Clearing text of Calender Input field once its value set to null
        this.$refs.input.value = ''
      }
    },
    computed: {
      type () {
        return this.pickerOptions.inline ? 'hidden' : 'text'
      },
      pickerOptions () {
        return {
          label: '',
          name: '',
          inline: false,
          minDate: null,
          maxDate: null,
          format: 'DD/MM/YYYY',
          field: false,
          noLabel: false,
          ...this.options
        }
      }
    },
    mounted () {
      this.startCalendar()
    },
    methods: {
      setDate (date) {
        this.picker.setDate(date)
      },
      resetSelectedDate() {
        this.selectedDate = null
      },
      startCalendar () {
        let parent = this
        let inModal = false
        while (parent) {
          parent = parent.$parent
          if (parent && parent.$options._componentTag) {
            inModal = parent.$options._componentTag.includes('modal')
            if (inModal) parent = false
          }
        }
        let theme = inModal ? 'in-modal-theme' : false
        this.picker = new Pikaday({
          field: this.pickerOptions.inline ? false : this.$refs.input,
          setDefaultDate: false,
          onSelect: async (date) => {
            this.selectedDate = date
            this.$emit('input', date.toISOString()) // Convert to string
            // await this.goToDate(date)
          },
          format: this.pickerOptions.format,
          minDate: moment(this.pickerOptions.minDate).toDate(),
          maxDate: moment(this.pickerOptions.maxDate).toDate(),
          theme,
          onDraw: async (date) => {
            if (this.options.highlightDates) {
              await this.loadDates({ selectedMonth: date.calendars[0] })
              if (this.selectedDate) {
                // Display reports for the selected date
                await this.goToDate(this.selectedDate)
                this.resetSelectedDate()
              } 
              else {
                // Display reports for the selected month
                await this.getMonthReports({ selectedMonth: date.calendars[0] }) 
                this.resetSelectedDate()
              }

              let buttons = document.getElementsByClassName('pika-button pika-day')
              await this.$nextTick()
              for (let i = 0; i < buttons.length; i++) {
                let year = buttons[i].attributes['data-pika-year'].nodeValue
                let month = buttons[i].attributes['data-pika-month'].nodeValue
                let day = buttons[i].attributes['data-pika-day'].nodeValue
                for (let date of this.selectedDates) {
                  if (moment(date).year().toString() === year &&
                  moment(date).month().toString() === month &&
                  moment(date).date().toString() === day) {
                    if (!dom(buttons[i]).hasClass('has-data')) {
                      dom(buttons[i]).addClass('has-data')
                    }
                  }
                }
              }
            }
          }
        })
        if (this.pickerOptions.inline) {
          this.$refs.input.parentNode.insertBefore(
            this.picker.el,
            this.$refs.input.nextSibling
          )
        }
      }
    },
    watch: {
      value(newValue) {
          // Update the calendar when the value prop changes
          this.picker.setDate(newValue);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/CalendarInput.vue